import IconBar from './IconBar';
export default IconBar;
